var _path, _circle, _path2, _path3, _path4, _path5, _g, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryHist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15669 40.8875C7.25455 34.9236 12.9792 30.9789 18.9432 32.0767L39.1648 35.7992C45.1287 36.897 49.0735 42.6217 47.9756 48.5856C47.7012 50.0766 46.27 51.0628 44.779 50.7883L8.35939 44.0841C6.86841 43.8097 5.88223 42.3785 6.15669 40.8875Z",
    fill: "#FFCF24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5605,
    cy: 47.0974,
    r: 5.0943,
    transform: "rotate(10.4304 21.5605 47.0974)",
    fill: "#F46D0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6556 20.9281C16.3069 11.9579 24.9173 6.02465 33.8876 7.67592C42.8579 9.32719 48.7911 17.9376 47.1398 26.9079L44.2744 42.4737C43.466 46.8655 39.2504 49.7703 34.8586 48.9619L18.2784 45.9097C13.8866 45.1013 10.9818 40.8857 11.7902 36.4939L14.6556 20.9281Z",
    fill: "#FFCF24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.453 5.9511C30.822 3.94668 32.746 2.62089 34.7504 2.98987C36.7548 3.35885 38.0806 5.28287 37.7117 7.2873L36.9996 11.1554C36.8091 12.1905 35.8154 12.8752 34.7802 12.6847L31.2703 12.0385C30.2351 11.848 29.5504 10.8543 29.741 9.81916L30.453 5.9511Z",
    fill: "#FFCF24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.528 11.5061C18.5792 13.4697 18.2167 16.5374 18.5291 17.8258C19.8109 20.5346 22.3671 20.082 27.43 19.2665C32.4929 18.451 33.7596 14.7935 32.8597 12.5177C31.9598 10.2418 27.4639 9.05155 22.528 11.5061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3311 34.1748C27.9173 36.5656 32.5893 36.5656 36.1755 34.1748",
    stroke: "#37204B",
    strokeWidth: 2.3689,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_757)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5991,
    cy: 26.6064,
    rx: 4.88523,
    ry: 4.88522,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5989,
    cy: 26.6062,
    r: 2.67899,
    fill: "#37204B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9565,
    cy: 26.6064,
    rx: 4.88523,
    ry: 4.88522,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9563,
    cy: 26.6062,
    r: 2.67899,
    fill: "#37204B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8389 19.84C23.1284 20.0726 22.5647 20.3876 22.2968 20.5753C21.7531 20.9563 21.0131 20.8101 20.644 20.2488C20.2749 19.6874 20.4165 18.9234 20.9603 18.5424C21.4226 18.2183 22.195 17.8006 23.1195 17.4979C24.0444 17.1952 25.1979 16.9825 26.3916 17.1551C27.0424 17.2491 27.4961 17.8701 27.405 18.542C27.3139 19.214 26.7124 19.6824 26.0615 19.5883C25.3293 19.4825 24.549 19.6075 23.8389 19.84ZM37.3861 17.4979C38.3106 17.8006 39.0829 18.2183 39.5453 18.5424C40.0891 18.9234 40.2307 19.6874 39.8616 20.2488C39.4925 20.8101 38.7525 20.9563 38.2087 20.5753C37.9409 20.3876 37.3772 20.0726 36.6667 19.84C35.9566 19.6075 35.1762 19.4825 34.444 19.5883C33.7932 19.6824 33.1917 19.214 33.1006 18.542C33.0094 17.8701 33.4632 17.2491 34.114 17.1551C35.3077 16.9825 36.4612 17.1952 37.3861 17.4979Z",
    fill: "#37204B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4316,
    height: 9.87035,
    fill: "white",
    transform: "translate(20.0371 21.6597)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryHist);
export default __webpack_public_path__ + "static/media/category_hist.d56456b96146195d32f3cee1b108339e.svg";
export { ForwardRef as ReactComponent };